import { useEffect, type ReactNode } from 'react';
import { useAuthState } from '../authState';

export function RequireAuth({ children }: Readonly<{ children: ReactNode }>) {
  const { isAuthenticated, isLoading, signinRedirect } = useAuthState();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) signinRedirect();
  }, [isLoading, isAuthenticated, signinRedirect]);

  if (!isAuthenticated) return null;
  return <>{children}</>;
}
